import React, { useEffect, useState } from "react";
import DonutChart from "../../../components/DonutChart";
import {
  FormControl,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { postRequest } from "../../../services/api";
import { useSelector } from "react-redux";

const ShipmentStatus = () => {
  const { startDate, endDate } = useSelector((state) => state.dashboard);
  const { user, userSetting } = useSelector((state) => state.user);
  const [type, setType] = useState("count");
  const [data, setData] = useState([])

  const handleChange = (e) => {
    setType(e.target.value);
  };  

  const formatShipmentData = (data) => {
   const formatResponse = data.map((item) => {
        let count = ''
        if(type === 'count') {
            count = item.cnt
        } else if(type === 'cuft') {
            count = item.CUFt
        } else {
            count = item.Pieces
        }
        let obj = {
            value: count,
            name : item.orderStatus
        }

        return obj
   });
   setData(formatResponse)
  };

  const fetchShipmentStaus = async () => {
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user?.token}`,
    };
    let payload = {
      custCode: userSetting?.[0]?.currCustomer,
      whseCode: userSetting?.[0]?.currWarehouse,
      fromDate: startDate.format("YYYY-MM-DD"),
      toDate: endDate.format("YYYY-MM-DD"),
    };
    const response = await postRequest(
      "user/getDashCounters",
      payload,
      headers
    );
    formatShipmentData(response.data.Payload);
  }


  useEffect(() => {
    fetchShipmentStaus();
  }, [startDate, endDate, type, userSetting]);

  

  return (
    <div>
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography>Shipment Status</Typography>
        <FormControl sx={{ m: 1, minWidth: 120 }}>
          <Select
            value={type}
            onChange={handleChange}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
          >
            <MenuItem value={"count"}>Count</MenuItem>
            <MenuItem value={"cuft"}>CUFt</MenuItem>
            <MenuItem value={"pieces"}>Pieces</MenuItem>
          </Select>
        </FormControl>
      </Stack>

      <DonutChart
        chartName={"shipment status"}
        chartData={data}
      />
    </div>
  );
};

export default ShipmentStatus;
